module.exports = __webpack_public_path__ + "img/live.551ff17e.png";